<template>
  <div class="main-content">
    <div class="modal" tabindex="-1" role="dialog" id="cancelUserSentModal">
      <div class="modal-dialog" role="document">
        <div class="modal-content" v-if="cancelUserSent.id">
          <div class="modal-header">
            <h5 class="modal-title">
              Cancelar envio de {{ cancelUserSent.user.name }}
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label>Motivo:</label>
                  <textarea
                    class="form-control"
                    rows="4"
                    v-model="cancelReason"
                  ></textarea>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Cancelar
            </button>
            <button
              type="button"
              @click="cancel(cancelUserSent)"
              class="btn btn-danger"
            >
              Confirmar
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- Filters -->
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header">
            <div
              class="card-title"
              data-toggle="collapse"
              data-target="#collapseFilter"
              role="button"
              aria-expanded="false"
              aria-controls="collapseFilter"
              style="cursor: pointer"
            >
              Filtros
              <button
                class="btn btn-inform"
                data-toggle="collapse"
                data-target="#collapseFilter"
                role="button"
                aria-expanded="false"
                aria-controls="collapseFilter"
              >
                <i class="fas fa-angle-down"></i>
              </button>
            </div>
          </div>

          <div class="collapse" id="collapseFilter">
            <div class="card-body">
              <div class="row">
                <div class="col-md-4">
                  <div class="form-group">
                    <label for="filterDateIn">Data Início</label>
                    <datetime
                      v-model="filters.dateStart"
                      class="form-control along"
                      :phrases="{ ok: 'Ok', cancel: 'Cancelar' }"
                      value-zone="America/Sao_Paulo"
                      zone="America/Sao_Paulo"
                      v-on:input="getBatches()"
                    ></datetime>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label for="filterDateEnd">Data Fim</label>
                    <datetime
                      v-model="filters.dateEnd"
                      class="form-control along"
                      :phrases="{ ok: 'Ok', cancel: 'Cancelar' }"
                      value-zone="America/Sao_Paulo"
                      zone="America/Sao_Paulo"
                      v-on:input="getBatches()"
                    ></datetime>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label for="filterSection">Usuários</label>
                    <v-select
                      :options="users"
                      label="name"
                      :reduce="(users) => users.id"
                      class="style-chooser"
                      id="sectors"
                      multiple
                      v-model="filters.user_id"
                      v-on:input="getBatches()"
                    >
                      <div slot="no-options">Nenhum registro encontrado.</div>
                    </v-select>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="filterSection">Busca por palavra chave</label>
                    <input
                      type="text"
                      v-model="filters.docto"
                      v-on:keyup.enter="getBatches()"
                      class="form-control"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-12">
        <div class="card">
          <div class="card-header">
            <div class="card-title">Gerenciamento de Assinaturas via API</div>
          </div>
          <div class="card-body">
            <div class="row">
              <!-- <div class="col-md-6">
                <div class="form-group">
                  <input
                    type="text"
                    class="form-control along"
                    id="filterSearch"
                    placeholder="Palavra chave..."
                    v-model="filters.docto"
                    @keyup="getBatches"
                  />
                </div>
              </div>-->
            </div>
            <div class="row">
              <div class="col-md-12">
                <p class="mb-3">Filtre pelo status dos documentos:</p>
              </div>
              <div class="col-md-3">
                <input
                  type="checkbox"
                  value="1"
                  v-model="filters.signed"
                  @change="getBatches()"
                  id="signed"
                  name="signed"
                />
                <label for="signed">
                  <i
                    class="fas fa-file-contract"
                    style="margin-left: 10px; margin-right: 10px"
                  ></i>
                  Concluído
                </label>
              </div>
              <div class="col-md-3">
                <input
                  type="checkbox"
                  v-model="filters.pending"
                  value="1"
                  @change="getBatches()"
                  id="pending"
                  name="pending"
                />
                <label for="pending">
                  <i
                    class="fas fa-file-contract"
                    style="margin-left: 10px; margin-right: 10px"
                  ></i>
                  Falha
                </label>
              </div>
            </div>
            <hr />
            <div class="row">
              <div class="col-md-12">
                <div class="table-responsive">
                  <table class="table table-hover">
                    <thead>
                      <tr>
                        <th scope="col" @click="setSort('id')">#ID</th>
                        <th scope="col">#ID do Lote</th>
                        <th scope="col">Nome Assinante</th>
                        <th scope="col">Tipo Processo</th>
                        <th scope="col">ID do Processo</th>
                        <th scope="col">Data Envio</th>
                        <th scope="col">Status</th>
                        <th scope="col">Mensagem</th>
                        <th scope="col">Ação</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="user_sent in batches" :key="user_sent.id">
                        <td>{{ user_sent.id }}</td>
                        <td>{{ user_sent.batch_id }}</td>
                        <td>{{ user_sent.nomeFunc }}</td>
                        <td>{{ user_sent.tipoProcesso }}</td>
                        <td>{{ user_sent.idProcesso }}</td>
                        <td>{{ user_sent.created_at }}</td>
                        <td>
                          <span
                            class="badge"
                            :class="[
                              user_sent.status == '1'
                                ? 'pastel-green'
                                : 'pastel-red',
                            ]"
                            >{{
                              user_sent.status == "1" ? "Concluído" : "Falha"
                            }}</span
                          >
                        </td>
                        <td>{{ user_sent.status_reason }}</td>
                        <td>
                          <button
                            @click="resend(user_sent)"
                            v-if="user_sent.status == 0"
                            class="btn btn-crud view"
                            data-tooltip="tooltip"
                            title="Tentar Novamente"
                          >
                            <i class="fas fa-retweet"></i>
                          </button>
                          <button
                            @click="det(user_sent)"
                            class="btn btn-crud edit"
                            data-tooltip="tooltip"
                            title="Visualizar Lote"
                            v-if="user_sent.status == 1"
                          >
                            <i class="far fa-eye"></i>
                          </button>
                          <!-- <button
                            v-if="user_sent.status == 0"
                            @click="cancelModal(user_sent)"
                            class="btn btn-crud delete"
                            data-tooltip="tooltip"
                            title="Cancelar"
                          >
                            <i class="fas fa-ban"></i>
                          </button> -->
                        </td>
                      </tr>
                      <tr v-if="batches.length == 0" align="center">
                        <td colspan="9">Nenhum registro encontrado.</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <pagination
              :records="total"
              :options="options"
              :per-page="10"
              @paginate="getBatches"
            ></pagination>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Documento -->
    <div
      class="modal fade"
      id="modalDocument"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              Visualização do Documento
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div>
            <iframe :src="document_http" class="iframe"></iframe>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Fechar
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Detalhe Assinatura -->

    <div
      class="modal fade"
      id="modalDetail"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
      v-if="detail.user"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              Detalhes da Assinatura
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="row content-detail">
            <div class="col-md-6" style="font-size: 16px">
              <i class="fas fa-user"></i>
              &nbsp;Assinado por {{ detail.user.name }}
            </div>

            <div class="col-md-6" style="font-size: 16px">
              <i class="fas fa-calendar-check"></i>
              &nbsp;Assinado em {{ detail.signed_at }}
            </div>
          </div>
          <div class="row content-detail">
            <div class="col-md-6" style="font-size: 16px">
              <i class="fas fa-globe-americas"></i>
              &nbsp;Assinado no IP {{ detail.users_signed[0].ip }}
            </div>
          </div>
          <div class="row content-detail">
            <div class="col-md-12" style="font-size: 16px">
              <i class="fas fa-map-marked-alt"></i>
              &nbsp;Geolocalização (Latitude: {{ detail.latitude }} | Longitude:
              {{ detail.longitude }})
            </div>
          </div>
          <div class="row content-detail">
            <div class="col-md-12">
              <iframe
                width="100%"
                height="250"
                frameborder="0"
                style="border: 0"
                :src="src"
                allowfullscreen
              ></iframe>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Fechar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Pagination } from "vue-pagination-2";
export default {
  data() {
    return {
      options: {
        texts: {
          count: "Mostrando {from} de {to} até {count} de registros",
        },
      },
      total: 0,
      document_http: "",
      src: "",
      detail: [],
      companies: [],
      branches: [],
      sectors: [],
      batches: [],
      users: [],
      filters: {
        dateStart: "",
        dateEnd: "",
        sector_id: "",
        branch_id: "",
        company_id: "",
        docto: "",
        pending: "",
        signed: "",
        late: "",
        cancel: "",
        sort: "",
        orientation: "",
        intern: "",
      },
      page: 2,
      orientation: "middle",
      cancelReason: "",
      cancelUserSent: "",
    };
  },
  computed: {
    filteredBranches: function () {
      var bcs = [];
      for (var i = 0; i <= this.filters.company_id.length; i++) {
        var b2 = this.branches.filter(
          (x) => x.company_id == this.filters.company_id[i]
        );
        bcs.push(b2[0]);
      }
      bcs.splice(i - 1);
      return bcs;
    },
    filteredSectors: function () {
      var scs = [];
      for (var i = 0; i <= this.filters.company_id.length; i++) {
        var c2 = this.sectors.filter(
          (x) => x.company_id == this.filters.company_id[i]
        );
        scs.push(c2[0]);
      }
      scs.splice(i - 1);
      return scs;
    },
  },
  methods: {
    resend(object) {
      const self = this;
      const api = self.$store.state.api + "signature-api-resend/";
      const fd = new FormData();
      fd.append("cancel_reason", self.cancelReason);
      self.$http
        .post(api, object)
        .then((response) => {
          self.getBatches();
          self.$message("Sucesso", "Reenviado com sucesso", "success");
        })
        .catch((error) => {
          self.$message("Erro", error.response.data, "error");
          self.getBatches();
        });
    },
    det(det) {
      this.$router.push("/signatureBatches/view/" + det.batch_id);
    },
    getCompanies: function () {
      const self = this;
      const api =
        self.$store.state.api + "companies?paginated=false&with[]=branches";
      self.$http
        .get(api)
        .then((response) => {
          self.companies = response.data.data;
        })
        .catch((error) => {
          self.$message("Erro", error.response.data, "error");
        });
    },
    getBranches: function () {
      const self = this;
      const api = self.$store.state.api + "branches?paginated=false";
      self.$http
        .get(api)
        .then((response) => {
          self.branches = response.data.data;
        })
        .catch((error) => {
          self.$message("Erro", error.response.data, "error");
        });
    },
    getSectors: function () {
      const self = this;
      const api = self.$store.state.api + "sectors?paginated=false";
      self.$http
        .get(api)
        .then((response) => {
          self.sectors = response.data.data;
        })
        .catch((error) => {
          self.$message("Erro", error.response.data, "error");
        });
    },
    getUsers: function () {
      const self = this;
      const api = self.$store.state.api + "users?paginated=false";
      self.$http
        .get(api)
        .then((response) => {
          self.users = response.data.data;
        })
        .catch((error) => {
          self.$message("Erro", error.response.data, "error");
        });
    },
    getBatches: function (page = null, sort = null) {
      const self = this;
      const api =
        self.$store.state.api +
        "signature-api-management?page=" +
        (page ? page : 1);
      self.$http
        .post(api, {
          filters: self.filters,
        })
        .then((response) => {
          self.batches = response.data.data;
          self.total = response.data.total;
        })
        .catch((error) => {
          self.$message("Erro", error.response.data, "error");
        });
    },
  },
  mounted() {
    this.getCompanies();
    this.getBranches();
    this.getSectors();
    this.getUsers();
    this.getBatches();
  },
  components: { Pagination },
};
</script>
<style scoped>
.content-detail {
  padding: 20px;
}
.date-time-picker .field-input[data-v-74507c40] {
  border: none;
  border-bottom: 2px solid #03a830;
  color: #03a830;
}
.along {
  height: 40px;
}

input[type="checkbox"] {
  position: absolute;
  z-index: -1;
  opacity: 0;
}

input[type="checkbox"] + label {
  font-size: 12px;
  padding: 2px 0 0;
  width: 100px;
  height: 25px;
  border: 2px solid #28a745;
  color: #424241;
  border-radius: 0.25rem;
}
input[type="checkbox"]:checked + label {
  border: 2px solid #03a830;
  color: #fff;
  background-color: #03a830;
  font-style: normal;
}

.iframe {
  width: 100%;
  height: 700px;
}
</style>


// WEBPACK FOOTER //
// src/components/SignatureBatch/Management/Api.vue